import React from 'react'

import type { ProductCardProps } from '@/types/components/cards/product-card'
import { ResponsiveImage } from '@/components/Shared/ResponsiveImage'
import { formatPrice } from '@/utilities/number'

import { AddToCartButton } from './AddToCartButton'

import './Feature.scss'
import { isProductCardVariantEnabled } from '@/utilities/commerce'

type Props = ProductCardProps

export const FeaturedProductCardV2: React.FC<Props> = ({ content }) => {
  const {
    title,
    slug,
    description,
    variants,
    activeVariant,
    featuredImage,
    featuredButtonType,
  } = content

  const enabledVariants = variants.filter(isProductCardVariantEnabled)
  if (!enabledVariants.length) return null

  const isSingleVariant = enabledVariants.length === 1
  const price = Math.min(...enabledVariants.map((variant) => variant.price))
  const compareAtPrice = Math.min(
    ...enabledVariants.map((variant) => variant.compareAtPrice || 0),
  )

  return (
    <div className="featured-product-card">
      <div className="featured-product-card__frame">
        {featuredImage && (
          <ResponsiveImage
            document={featuredImage}
            overrides={{
              desktopAspectRatio: 'auto',
              mobileAspectRatio: '16/9',
              objectFit: 'cover',
            }}
          />
        )}
      </div>
      <div className="featured-product-card__body">
        <div className="featured-product-card__heading">
          <a
            className="featured-product-card__title type-h4"
            href={`/products/${slug}?variant=${activeVariant.id}`}
          >
            {title}
          </a>
          <div className="featured-product-card__description">
            {description}
          </div>
        </div>
        <div className="featured-product-card__price type-eyebrow">
          {!!compareAtPrice && (
            <span className="featured-product-card__compare-price">
              {formatPrice(compareAtPrice)}
            </span>
          )}
          <span className="featured-product-card__actual-price">
            {isSingleVariant
              ? formatPrice(price)
              : `From ${formatPrice(price)}`}
          </span>
        </div>
        <AddToCartButton
          productCardItem={content}
          buttonType={featuredButtonType || 'primaryArrow'}
          classes={['featured-product-card__cta']}
        />
      </div>
    </div>
  )
}
